import type { createWikoRpcSubscriptionsApi } from '@wiko/rpc-subscriptions-api';

import { createWikoJsonRpcIntegerOverflowError } from './rpc-integer-overflow-error';

export const DEFAULT_RPC_SUBSCRIPTIONS_CONFIG: Partial<
    NonNullable<Parameters<typeof createWikoRpcSubscriptionsApi>[0]>
> = {
    defaultCommitment: 'confirmed',
    onIntegerOverflow(request, keyPath, value) {
        throw createWikoJsonRpcIntegerOverflowError(request.methodName, keyPath, value);
    },
};
